import React, { Component } from 'react';

import JSONLDUtils from 'common/util/JsonLdUtils';

import Helmet from './Helmet';

const Title = 'Feature Request Management Software | Canny';
const Description =
  "Canny's feature request management tools let you collect, organize, and analyze feedback with ease. Create your feature request board today! Start for free!";
const Image = 'https://canny.io/images/canny-social.png';
const FeatureRequestManagementUrl = 'https://canny.io/use-cases/feature-request-management';

const jsonLdGraph = JSONLDUtils.createGraph([
  JSONLDUtils.createWebPage({
    '@id': `${FeatureRequestManagementUrl}#webpage`,
    url: FeatureRequestManagementUrl,
    name: 'Feature Request Management - Canny',
    description:
      'Streamline feature request management with Canny — collect, organize, and prioritize requests to build customer-driven products.',
    inLanguage: 'en',
    about: { '@id': 'https://canny.io/#app' },
    isPartOf: { '@id': 'https://canny.io/#website' },
  }),
  JSONLDUtils.createWebApplicationItemList(
    `${FeatureRequestManagementUrl}#benefits`,
    'Feature Request Management Capabilities',
    [
      {
        name: 'Collect Feature Requests',
        description:
          'Gather requests from customers via feedback boards, in-app widgets, and integrations with tools like Intercom and Zendesk.',
      },
      {
        name: 'Organize & Prioritize Requests',
        description:
          'Categorize and rank feature requests by customer impact, votes, and strategic value.',
      },
      {
        name: 'Integrate with Product Workflows',
        description:
          'Connect with tools like Jira, Slack, and GitHub to bring feature management into your development process.',
      },
      {
        name: 'Close the Feedback Loop',
        description:
          'Notify customers when their requests are addressed to improve satisfaction and engagement.',
      },
    ],
  ),
  JSONLDUtils.createBreadcrumbList([
    { name: 'Home', item: 'https://canny.io/' },
    { name: 'Use Cases', item: 'https://canny.io/use-cases' },
    { name: 'Feature Request Management', item: FeatureRequestManagementUrl },
  ]),
]);

export default class LandingHelmet extends Component {
  render() {
    return (
      <Helmet
        title={Title}
        meta={[
          { name: 'description', content: Description },

          { property: 'og:image', content: Image },
          { property: 'og:title', content: Title },
          { property: 'og:description', content: Description },
          { property: 'og:url', content: FeatureRequestManagementUrl },
          { property: 'og:type', content: 'website' },

          { name: 'twitter:card', content: 'summary_large_image' },
          { name: 'twitter:site', content: '@cannyHQ' },
          { name: 'twitter:title', content: Title },
          { name: 'twitter:description', content: Description },
          { name: 'twitter:image', content: Image },
        ]}>
        <script type="application/ld+json">{JSONLDUtils.toString(jsonLdGraph)}</script>
      </Helmet>
    );
  }
}
